export default {
  getAccounts: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts/getters.js